// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d81b33b","455":"87e4945f","977":"b6ff784c"}[chunkId] + ".chunk.js";
};